import { useLanguage, t } from "../../../i18n";
import React from "react";
import { NavLink } from "react-router-dom";
import { HiOutlineHome, HiOutlineBuildingOffice2, HiOutlineClipboardDocumentList, HiOutlineUser, HiOutlineHeart } from "react-icons/hi2";
import "./NavigationMenu.css";
const navItems = [{
  id: 1,
  label: "Home",
  path: "/home",
  icon: HiOutlineHome
}, {
  id: 2,
  label: "Room Listings",
  path: "/room-listings",
  icon: HiOutlineBuildingOffice2
}, {
  id: 3,
  label: "My Posts",
  path: "/my-posts",
  icon: HiOutlineClipboardDocumentList
}, {
  id: 4,
  label: "Shortlist",
  path: "/shortlist",
  icon: HiOutlineHeart
}, {
  id: 5,
  label: "Profile",
  path: "/profile",
  icon: HiOutlineUser
}];
export default function NavigationMenu({
  onNavigate
}) {
  useLanguage();
  return <div className="bb-navigation-menu">
      <div className="bb-navigation-links">
        {navItems.map(item => {
        const Icon = item.icon;
        return <NavLink key={item.id} to={item.path} onClick={onNavigate} className={({
          isActive
        }) => `bb-navigation-link ${isActive ? "active" : ""}`}>

              <span className="bb-navigation-icon">
                <Icon />
              </span>
              <span className="bb-navigation-label">{t(item.label)}</span>
            </NavLink>;
      })}
      </div>


    </div>;
}
